<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>
    <div class="px-2 mt-1">
      <div class="card card-height">
        <div class="row mt-2 gy-1">
          <div class="row mt-1">
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
              <label class="form-label">Name <span class="required">*</span></label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  placeholder="Name...."
                  v-model="formData.name"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Short Name</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  placeholder="Short Name...."
                  v-model="formData.short_name"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Description</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  placeholder="Description...."
                  v-model="formData.description"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Type <span class="required">*</span></label>
              <v-select
                  placeholder="Select Type"
                  v-model="formData.type"
                  :options="payHeadType"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Income Type <span class="required">*</span></label>
              <v-select
                  placeholder="Select Income Type"
                  v-model="formData.income_type"
                  :options="payHeadIncomeType"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle me-2">Gross Salary Component: </label>
              <input type="checkbox" v-model="formData.gross_salary_component" class="form-check-input">
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Calculation Type <span class="required">*</span></label>
              <v-select
                  placeholder="Select Calculation Type"
                  v-model="formData.calculation_type"
                  :options="payHeadCalculationType"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div v-if="formData.calculation_type === 'percentage_of_pay_head'" class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Pay Head</label>
              <v-select
                  placeholder="Select Type"
                  v-model="formData.pay_head_id"
                  :options="payHeads"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Value</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  step="any"
                  type="number"
                  placeholder="Value...."
                  v-model="formData.value"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Calculation Period <span class="required">*</span></label>
              <v-select
                  placeholder="Select Calculation Period"
                  v-model="formData.calculation_period"
                  :options="payHeadCalculationPeriod"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Payroll Category <span class="required">*</span></label>
              <v-select
                  placeholder="Select Payroll Category"
                  v-model="formData.payroll_category"
                  :options="payrollCategoryList"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div v-if="formData.payroll_category == 'loan'" class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
              <label class="align-middle">Payroll Category Type</label>
              <v-select
                  placeholder="Select Payroll Category Type"
                  v-model="formData.payroll_category_type"
                  :options="payrollCategoryTypeList"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div v-if="!isCreate" class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Status</label>
              <v-select
                  placeholder="Select Policy"
                  v-model="formData.status"
                  :options="status"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP()"
              class="btn btn-primary">
        Save
      </button>
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP(false)"
              class="btn btn-primary">Save & New
      </button>
      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <GlobalLoader/>
  </div>
</template>
<script setup>
import {computed, inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useStore} from "vuex";

const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})

let loader =ref(false)
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let headerTitle = ref("Add Pay Head")
let payHeadEditData = ref({})
const status = ref([]);
const payHeads = ref([]);
const payHeadType = ref([]);
const payHeadIncomeType = ref([]);
const payHeadCalculationType = ref([]);
const payHeadCalculationPeriod = ref([]);
const payrollCategoryList = ref([]);
const payrollCategoryTypeList = ref([]);
let payHeadData = {}
let formData = ref({
  company_id: companyId,
  status: 'active',
  name:'',
  short_name:'',
  description:'',
  type:'',
  income_type:'',
  gross_salary_component:false,
  calculation_type:'',
  pay_head_id:'',
  value:'',
  calculation_period:'',
  payroll_category:'',
  payroll_category_type:'',
})

function navigateToListPage() {
  delete route.query.payHeadId;
  router.push({name: `pay-head`, params: route.params, query: route.query});
}

const {
  createPayHead,
  fetchPayHead,
  fetchSinglePayHead,
  updatePayHead,
  fetchTypes,
} = handleHrPayroll()

function saveAP(redirect = true) {
  if (isCreate.value) {
    handleSubmit(redirect);
  }

  if (!isCreate.value) {
    handleUpdate(redirect);
  }
}

function handleSubmit(redirect) {
  payHeadData.company_id  = formData.value.company_id;
  payHeadData.status = "active";
  payHeadData.name = formData.value.name;
  payHeadData.short_name = formData.value.short_name;
  payHeadData.description = formData.value.description;
  payHeadData.type = formData.value.type;
  payHeadData.income_type = formData.value.income_type;
  payHeadData.gross_salary_component = formData.value.gross_salary_component;
  payHeadData.calculation_type = formData.value.calculation_type;
  payHeadData.pay_head_id = formData.value.pay_head_id ? formData.value.pay_head_id.id : null;
  payHeadData.value = formData.value.value;
  payHeadData.calculation_period = formData.value.calculation_period;
  payHeadData.payroll_category = formData.value.payroll_category;
  payHeadData.payroll_category_type = formData.value.payroll_category_type;

  createPayHeadData(redirect);
}

function handleUpdate(redirect) {
  payHeadData.id = formData.value.id;
  payHeadData.company_id  = formData.value.company_id;
  payHeadData.status = formData.value.status;
  payHeadData.name = formData.value.name;
  payHeadData.short_name = formData.value.short_name;
  payHeadData.description = formData.value.description;
  payHeadData.type = formData.value.type;
  payHeadData.income_type = formData.value.income_type;
  payHeadData.gross_salary_component = formData.value.gross_salary_component;
  payHeadData.calculation_type = formData.value.calculation_type;
  payHeadData.pay_head_id = formData.value.pay_head_id ? formData.value.pay_head_id.id : null;
  payHeadData.value = formData.value.value;
  payHeadData.calculation_period = formData.value.calculation_period;
  payHeadData.payroll_category = formData.value.payroll_category;
  payHeadData.payroll_category_type = formData.value.payroll_category_type;

  updatePayHeadData(redirect);
}

function createPayHeadData(redirect = true) {
  createPayHead(payHeadData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message)
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function updatePayHeadData(redirect = true) {
  updatePayHead(payHeadData, payHeadData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message);
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

function setFormData() {
  headerTitle.value = "Update Pay Head";
  formData.value.id =  payHeadEditData.value.id;
  formData.value.name = payHeadEditData.value.name;
  formData.value.short_name = payHeadEditData.value.short_name;
  formData.value.description = payHeadEditData.value.description;
  formData.value.type = payHeadEditData.value.type;
  formData.value.income_type = payHeadEditData.value.income_type;
  formData.value.gross_salary_component = payHeadEditData.value.gross_salary_component === 1;
  formData.value.calculation_type = payHeadEditData.value.calculation_type;
  formData.value.pay_head_id = {
    id:payHeadEditData.value.pay_head_id,
    name:payHeadEditData.value.parent_name
  };
  formData.value.value = payHeadEditData.value.value;
  formData.value.calculation_period = payHeadEditData.value.calculation_period;
  formData.value.payroll_category = payHeadEditData.value.payroll_category;
  formData.value.payroll_category_type = payHeadEditData.value.payroll_category_type;
  formData.value.status = payHeadEditData.value.status;
}

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      status.value = [];
      payHeadType.value = [];
      payHeadIncomeType.value = [];
      payHeadCalculationType.value = [];
      payHeadCalculationPeriod.value = [];
      payrollCategoryList.value = [];
      payrollCategoryTypeList.value = [];
      return
    }

    const data = res.data || {};

    status.value = data.status || [];
    payHeadType.value = data.payHeadType || [];
    payHeadIncomeType.value = data.payHeadIncomeType || [];
    payHeadCalculationType.value = data.payHeadCalculationType || [];
    payHeadCalculationPeriod.value = data.payHeadCalculationPeriod || [];
    payrollCategoryList.value = data.payrollCategory || [];
    payrollCategoryTypeList.value = data.payrollCategoryType || [];

  }).catch(err => {
    console.log(err)
  })
}

const getPayHeads = async () => {
  let query = getQuery();
  query += '&is_all=true&status=active'
  await fetchPayHead(query).then(res => {
    if (!res.status){
      payHeads.value = [];
      return
    }
    payHeads.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

function onPageReload() {
  loader.value=true

  Promise.all([
    getTypes(),
    getPayHeads()
  ]).finally(() => {
    loader.value = false
  })

  if(route.query.payHeadId && route.query.payHeadId !== '' && route.query.payHeadId !== undefined){
    isCreate.value = false;
    const fetchData = fetchSinglePayHead(route.query.payHeadId, getQuery());
    fetchData.then(res2 => {
      payHeadEditData.value = res2.data;
      setFormData();
    });
  }
}

onMounted(() => {
  onPageReload();
})
</script>